import React from "react";
import p1 from "../../assets/Images/P1.png";
import p2 from "../../assets/Images/P2.png";
import lad from "../../assets/Images/11.png";
import snow from "../../assets/Images/12.png";

const images = [
  {
    src: p1,
    alt: "Tourists enjoying a scenic view in Ladakh",
  },
  {
    src: p2,
    alt: "Mountain landscape with clear blue skies in Ladakh",
  },
  {
    src: lad,
    alt: "Beautiful valley surrounded by mountains in Ladakh",
  },
  {
    src: snow,
    alt: "Snow-covered mountains and scenic landscape in Ladakh",
  },
];

const Glimpse = () => {
  return (
    <div className="text-center pt-5">
      <div className="container-fluid px-0">
        <div className="row g-0">
          {images.map((image, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <img
                src={image.src}
                alt={image.alt}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Glimpse;